export default __webpack_public_path__ + "static/media/deliver.25f03cde.png";